import React from 'react'

import SectionTitle from '../components/SectionTitle'
import ParagraphWithImage from '../components/ParagraphWithImage'
import TileTitle from '../components/TileTitle'

const AboutSection = props => {
  const { data } = props

  return (
    <div>
      <SectionTitle leader trailer>
        {data.frontmatter.sectiontitle}
      </SectionTitle>
      <TileTitle>{data.frontmatter.sub_title}</TileTitle>
      <ParagraphWithImage number="01" data={data} />
    </div>
  )
}

export default AboutSection



// WEBPACK FOOTER //
// ./src/components/AboutSection.js